import React, { useEffect, useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Card,
  CardContent,
  Divider,
} from '@mui/material';
import gelir from '../../../../../../assets/gelir.png';
import useProfile from '../../../../../../hooks/useProfile';

interface KuikPaymentModalProps {
  open: boolean;
  onClose: () => void;
  onSecontTransactionPaymentKuik: (terminalId: number) => void;
  terminals: any;
  onConfirm: (terminalId: number, taxRate?: number) => void;
  priceOrderList: any;
  paymentList: any;
  totalPrice: number;
  handleAddOrderTransactionPayment: (
    paymentAction: number,
    taxRate?: number,
  ) => void;
  allPrice: number;
}

const KuikPaymentModal: React.FC<KuikPaymentModalProps> = ({
  open,
  onClose,
  terminals,
  totalPrice,
  handleAddOrderTransactionPayment,
  onConfirm,
  onSecontTransactionPaymentKuik,
  allPrice,
  priceOrderList,
  paymentList,
}) => {
  const [selectedPOS, setSelectedPOS] = useState<number | null>();
  const [selectedKdvRate, setSelectedKdvRate] = useState<number | string>('');
  const { meProfile } = useProfile();

  useEffect(() => {
    setSelectedKdvRate(meProfile?.activeBranch?.setting.tax_rate);
  }, [meProfile]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 800,
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          p: 3,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
          <img
            src={gelir}
            alt="Logo"
            style={{
              width: 30,
              height: 30,
              marginRight: 8,
              verticalAlign: 'middle',
            }}
          />
          Belgelendirme
        </Typography>
        <Divider />

        <Grid container spacing={2} sx={{ minHeight: 200 }}>
          <Grid
            item
            xs={5}
            sx={{ display: 'flex', flexDirection: 'column', mt: 2 }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
              Belgelendirme Detayı
            </Typography>

            <Typography variant="body2">
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '200px',
                }}
              >
                Ödeme Yöntemi
              </div>
            </Typography>

            <Typography variant="body2">
              {paymentList.map((item: any, index: number) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '200px',
                  }}
                >
                  <span>
                    {item.payment_type_id === 34
                      ? 'Kuik Nakit'
                      : item.payment_type_id === 35
                      ? 'Kuik Kredi Kartı'
                      : 'Diğer'}
                  </span>
                  <span>{item.amount.toFixed(2)}₺</span>
                </div>
              ))}
            </Typography>

            <Typography variant="body2" sx={{ fontWeight: 'bold', mt: 1 }}>
              Toplam Tutar:{' '}
              {paymentList
                .reduce((total: number, item: any) => total + item.amount, 0)
                .toFixed(2)}
              ₺
            </Typography>
            {paymentList.every(
              item => !item.orders || item.orders.length === 0,
            ) && (
              <Box sx={{ mt: 3 }}>
                <FormControl fullWidth size="small">
                  <InputLabel id="kdv-oran-label">
                    Varsayılan KDV Oranı
                  </InputLabel>
                  <Select
                    labelId="kdv-oran-label"
                    id="kdv-oran-select"
                    value={selectedKdvRate || ''}
                    label="Varsayılan KDV Oranı"
                    onChange={e => setSelectedKdvRate(e.target.value)}
                  >
                    <MenuItem value={0}>%0</MenuItem>
                    <MenuItem value={1}>%1</MenuItem>
                    <MenuItem value={10}>%10</MenuItem>
                    <MenuItem value={20}>%20</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            )}
          </Grid>

          <Grid item>
            <Divider orientation="vertical" flexItem sx={{ height: '100%' }} />
          </Grid>

          <Grid
            item
            xs={5}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
              POS Seçimi
            </Typography>
            <Grid
              container
              sx={{ mb: 4, mt: 1 }}
              spacing={2}
              justifyContent="flex-start"
            >
              {terminals
                ?.filter(
                  (terminal: any) =>
                    terminal.pairing_result?.cloud?.data.pairingCode,
                )
                .map((terminal: any) => (
                  <Grid item key={terminal.id}>
                    <Card
                      onClick={() => setSelectedPOS(terminal.id)}
                      sx={{
                        cursor: 'pointer',
                        border:
                          selectedPOS === terminal.id
                            ? '3px solid #4CAF50'
                            : '1px solid #ddd',
                        borderRadius: 2,
                        textAlign: 'center',
                        width: 90,
                        height: 90,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor:
                          selectedPOS === terminal.id
                            ? 'rgba(76, 175, 80, 0.2)'
                            : 'inherit',
                        opacity: selectedPOS !== terminal.id ? 0.5 : 1,
                      }}
                    >
                      <CardContent
                        sx={{
                          textAlign: 'center',
                          p: 0,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{ fontWeight: 'bold' }}
                        >
                          {terminal.name}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
            </Grid>
          </Grid>
        </Grid>

        <Divider sx={{ mb: 2 }} />

        <Box display="flex" justifyContent="space-between">
          <Button variant="contained" color="error" onClick={onClose}>
            Vazgeç
          </Button>
          <div>
            <Button
              variant="contained"
              color="success"
              sx={{ mr: 2 }}
              onClick={() =>
                handleAddOrderTransactionPayment(
                  12,
                  selectedKdvRate ? Number(selectedKdvRate) : undefined,
                )
              }
            >
              Belgesiz Kapat
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={() =>
                onConfirm(
                  selectedPOS!,
                  selectedKdvRate ? Number(selectedKdvRate) : undefined,
                )
              }
              disabled={!selectedPOS}
            >
              Öde
            </Button>
          </div>
        </Box>
      </Box>
    </Modal>
  );
};

export default KuikPaymentModal;
